"use client";

import Image from "next/image";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const advantageKeys = [
  "World-class Hospitals",
  "Experienced Specialists",
  "Advanced Medical Technology",
  "High-Value Care",
];

export default function WhyChooseChina() {
  const { t } = useI18n();
  return (
    <section className="mx-5 mt-3.5">
      <div className="relative min-h-[144px] rounded-2xl overflow-hidden bg-gradient-to-r from-[#EAF8F4] via-[#E4F6EF] to-[#D8F1E8]">
        {/* Skyline photo, faded into the card on its left edge */}
        <div className="absolute right-0 top-0 h-full w-[52%]">
          <Image
            src="/images/shanghai-skyline.jpg"
            alt="Shanghai skyline"
            fill
            sizes="(max-width: 430px) 230px, 230px"
            className="object-cover object-[62%_50%]"
            style={{
              maskImage: "linear-gradient(90deg, transparent 0%, #000 30%)",
              WebkitMaskImage: "linear-gradient(90deg, transparent 0%, #000 30%)",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#E4F6EF] via-[#E4F6EF]/55 to-transparent w-[70%]" />
        </div>

        <div className="relative z-10 h-full px-4 py-3.5">
          <h3 className="text-[17px] font-bold text-text-dark tracking-[-0.2px]">
            {t("Why Choose China?")}
          </h3>
          <ul className="mt-2 space-y-1.5">
            {advantageKeys.map((item) => (
              <li key={item} className="flex items-center gap-2">
                <CheckCircle2 size={13} className="shrink-0 text-primary" strokeWidth={2.4} />
                <span className="text-[14px] font-medium text-text-dark/85">{t(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
